export class CurriculumCatalogBaseSubjectAreaModel {
	id: number;
	title: string;
	short_code: string;
}
